import { FC, useEffect } from "react";
import { Button, HStack, Text } from "@chakra-ui/react";

import { useAppModal } from "../../../Modals";
import { Info2Icon } from "../../../../icons";
import { LocalStorageKeys } from "../../../../../constants";
import { PaymentBlockOperationInProgressModal } from "./PaymentBlockOperationInProgressModal.tsx";
import { queryClient } from "../../../../../api";
import { useCheckActivePaymentQuery } from "../../../../../api/payments";

export const PaymentBlockOperationInProgress: FC = () => {
  const { showModal } = useAppModal();
  const { data, isFetching, isError } = useCheckActivePaymentQuery();

  const onClick = () => {
    showModal({
      content: onClose => (
        <PaymentBlockOperationInProgressModal
          amount={data?.amount}
          onClose={onClose}
        />
      ),
    });
  };

  useEffect(() => {
    const STORAGE_KEY = LocalStorageKeys.hasActivePayment;

    if (data?.isPaymentActive) {
      localStorage.setItem(STORAGE_KEY, "true");
    }

    if (!data?.isPaymentActive && localStorage.getItem(STORAGE_KEY) === "true") {
      localStorage.removeItem(STORAGE_KEY);
      void queryClient.invalidateQueries();
    }
  }, [data]);

  if (isFetching || isError || data?.isPaymentActive !== true) {
    return null;
  }

  return (
    <HStack mt="14px" justifyContent="space-between">
      <Text fontSize="14px">Операция в обработке</Text>

      <Button minW="20px" h="20px" p="0" colorScheme="transparent" onClick={onClick}>
        <Info2Icon />
      </Button>
    </HStack>
  );
};
